import React from 'react'
import Accordions from '../containers/FAQs/Accordians'
import Seo from '../common/Components/Seo/Seo'
import FaqSchema from '../common/Components/StructuredData/FaqSchema'

const Faqs = () => {
  return (
    <div>
      <Seo
        seo={{
          title: "Frequently Asked Questions (FAQs) | Airport Parking Deals Help Center",
          description: "Find answers to common questions about airport parking bookings, payment methods, cancellations, and more. Get instant help with Airport Parking Deals comprehensive FAQ section.",
          keywords: "airport parking FAQs, frequently asked questions, parking booking help, airport parking questions, meet and greet FAQ, park and ride questions, booking assistance"
        }}

      />
      <div className="w-full bg-[#0C735F] h-28 md:h-[180px]"></div>

      <FaqSchema />
      <Accordions />
    </div>
  )
}

export default Faqs
